import { calculate_md5 } from "./crypto_utils.js";

export class SecureLocalStorage {
  private readonly seed: string;
  private readonly storage: Storage;

  constructor(seed: string) {
    this.seed = seed;
    this.storage = globalThis.localStorage;
  }

  save(key: string, value: string): Promise<boolean> {
    return new Promise<boolean>(async (resolve) => {
      let success: boolean = false;
      try {
        this.storage.setItem(key, value);
        const hash_value = await calculate_md5(value + this.seed);
        if (typeof hash_value === "string") {
          this.storage.setItem(`${key}_data`, hash_value);
          success = true;
        }
      } catch (err) {
        // no-op
      }
      resolve(success);
    });
  }

  get_value(key: string): Promise<string | undefined> {
    return new Promise(async (resolve) => {
      let value: string | undefined = undefined;
      try {
        const raw_value = this.storage.getItem(key);
        const hashed_value = this.storage.getItem(`${key}_data`);

        if (typeof raw_value === "string" && typeof hashed_value === "string") {
          const hashed_raw_value = await calculate_md5(raw_value + this.seed);
          if (hashed_raw_value === hashed_value) {
            value = raw_value;
          }
        }
      } catch (err) {
        // no-op
      }
      resolve(value);
    });
  }
}
